import React from 'react'

const Options = (props) => {
  const { handleNextClick, handleChange, locationData, optionIndex } = props
  const options = locationData.options
  const isDisabled = optionIndex === null

  return (
    <section className="section animated fadeIn">
      <div className="columns">
        <div className="column is-third is-offset-one-quarter">
          <div className="container has-text-left">
            <h1 className="title has-text-primary">
              I am interested in:
            </h1>
            <div className="field">
              <div className="control">
                {options.map((option, i) => {
                    return (
                      <label className="radio" key={i}>
                        <input type="radio" name="option" onChange={() => handleChange(option, i)} />
                        <span> {option.label}</span>
                      </label>
                    )
                })}
              </div>
            </div>
            <button disabled={isDisabled} style={{marginTop: 30}} className="button is-primary is-large" onClick={() => handleNextClick()}>Next</button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Options


// WEBPACK FOOTER //
// ./src/views/Options.js